<template>
<div>
  <el-row>
    <el-col :sm="12" :lg="6">
      <el-result icon="warning" title="警告提示" subTitle="请根据提示进行操作">
        <template slot="extra">
          <el-button type="primary" size="medium" @click="BackToActivityBoard">返回</el-button>
        </template>
      </el-result>
    </el-col>
  </el-row>
</div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        query: '',
        token: ''
      },
      qzjyUserList: [],
      total: 0
    }
  },
  created () {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getqzjyUserList()
  },
  methods: {
    async getqzjyUserList () {
      // this.loading = true
      const { data: res } = await this.$http.get('qzjyuser/', { params: this.queryInfo })
      this.qzjyUserList = res
      this.total = res.length
      console.log(this.qzjyUserList)
      console.log(this.total)
      for (let i = 0; i < this.qzjyUserList.length; i++) {
        if (this.qzjyUserList[i].username.search('teacher') !== -1) {
          console.log('i=', i)
          console.log((this.qzjyUserList[i]))
          // this.qzjyList.remove(this.qzjyList[i])
          this.qzjyUserList.splice(i, 1)
          console.log('after:', this.qzjyUserList)
          console.log((this.qzjyUserList.length))
        }
      }
      this.qzjyUserList.reverse()
      if (res.total === 0) return this.$notify({ title: '失败', message: '获取账号信息失败!', type: 'error' })
      // this.loading = false
      this.$notify({ title: '成功', message: '获取账号信息成功!', type: 'success' })
    },
    BackToActivityBoard() {
      console.log('back to activity')
      this.$router.push('/activity')
    }
  }
}
</script>
